import React from 'react';

export default function WhyNow() {
  return (
    <section className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto space-y-12">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Why Now?</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            The financial market is changing rapidly — and it needs infrastructure built for the future of work, trust, and monetization.
          </p>
        </div>

        {/* Trends Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">📈 Rise of Financial Creators</h3>
            <p>
              From YouTube analysts to signal providers and educators — the number of professionals monetizing finance content has exploded.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🌍 Global Retail Participation</h3>
            <p>
              Millions of new traders and learners are entering the markets from Africa, India, LATAM, and SEA — with little infrastructure to support them.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🧠 Shift to Role-Based Reputation</h3>
            <p>
              Reputation is moving from brands to verified individuals. Traders want to be known for their strategies, educators for their success rate, etc.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🔗 Still No Trusted Unified Layer</h3>
            <p>
              Even with dozens of fintech apps, there’s no foundational platform for market professionals to build, connect, and grow sustainably.
            </p>
          </div>

        </div>

        {/* Closing Statement */}
        <div className="text-center pt-12 text-gray-400 text-base max-w-3xl mx-auto">
          <p>
            The infrastructure gap is real. M2T is solving it with identity, monetization, and marketplace primitives — role by role, market by market.
          </p>
        </div>

      </div>
    </section>
  );
}
